import useEditSegment, {
  EditSegmentProps,
} from 'modules/segments/hooks/use-edit-segment';
import {SegmentProps, translatedSegmentProps} from 'modules/segments/types';
import segmentsKeys from 'modules/segments/util/segments-keys';
import React from 'react';
import {useParams} from 'react-router-dom';
import Edition from 'shared/layout/edition';
import useFormInputs from 'shared/migration-components/form/util';

const EditSegment: React.FC = () => {
  const {id} = useParams();
  const {getInput, getSwitch, getImagePicker, getSelect} = useFormInputs();

  const handleSubmit = ({name, active, aspectRatio, image}: SegmentProps) => {
    const formData = new FormData();

    formData.append('name', name);
    formData.append('aspectRatio', aspectRatio);
    formData.append('active', String(active));
    if ((image as any) instanceof File) formData.append('image', image);

    return formData;
  };

  return (
    <Edition<EditSegmentProps>
      {...{handleSubmit}}
      titleBar={{title: 'Editar segmento'}}
      inputs={[
        getInput({name: 'name'}),
        getSwitch({
          name: 'active',
        }),
        getSelect({
          name: 'aspectRatio',
          data: [
            {label: '1/2', value: '1/2'},
            {label: '1/4', value: '1/4'},
          ],
        }),
        getImagePicker({label: 'Imagem', name: 'image'}),
      ]}
      detailsUrl={`/segments/${id}`}
      onSubmit={() => useEditSegment(id!)}
      translationKey={translatedSegmentProps}
      queryKey={segmentsKeys.details(id!)}
    />
  );
};

export default EditSegment;
